import { useState } from 'react'
import { motion } from 'framer-motion'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../utils/getAssets'
import { useNavigate } from 'react-router-dom'

const Card = ({ item, itemVariants }) => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    if (item.path) {
      navigate(item.path)
    }
  }
  console.log("item",item)
  return (
    <motion.div
      className='course h-[40rem] md:h-[30rem] 2xl:h-[40rem]  relative overflow-hidden  group  bg-gray-400 flex rounded-3xl cursor-pointer hover:scale-105 transition-all duration-500'
      variants={itemVariants}
      whileHover='hover'
      onClick={handleNavigate}
    >
      <img
        src={item.image}
        alt={'imgage'}
        height={500}
        width={290}
        loading='lazy'
        className='w-full h-[40rem] object-cover   group-hover:scale-[1.2] transition-all !duration-500'
      />
      <div className='absolute inset-0 bg-[rgba(0,0,0,0.2)]'></div>

      <div className='absolute inset-0 bg-gradient-to-b from-[#636e6871] to-[#64637b71] z-10'></div>

      <div className='absolute bottom-0 left-0 right-0 p-4 min-h-24 z-20 text-white '>
        <h2 className=' mb-2 text-[30px] lg:text-[30px] group-hover:lg:text-[35px] 2xl:text-[40px] font-bold group-hover:2xl:text-[45px] transition-all !duration-500'>
          {item.title}
        </h2>
      </div>
    </motion.div>
  )
}

const ResearchSection = ({ data }) => {


  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12
      }
    },
    hover: {
      scale: 1.03,
      boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 10
      }
    }
  }


  return (
    <motion.div
      className='w-full min-h-96 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10'
      variants={containerVariants}
      initial='hidden'
      animate='visible'
    >
      <motion.div
        className='w-full flex h-full md:col-span-2 lg:col-span-1 gap-5 justify-center items-center lg:justify-between'
        initial={{ x: -50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className='flex items-start justify-start gap-3 flex-col'>
          <motion.h1
            className='text-4xl font-bold gradient_text mb-4'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            {data?.ourCampusTitle}
          </motion.h1>
          <motion.p
            className='text-gray-600 mb-8 '
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            {DecodeHtml({ html: data?.ourCampusDescription?.markup })}
          </motion.p>
        </div>
        <div className='w-[2px] hidden lg:block  h-full bg_gradient' />
      </motion.div>

      {data?.campusCardComponent?.items?.map((item,i) => (
        <Card
          key={i}
          item={{
            title: DecodeHtml({
              html: item?.content?.properties?.title?.markup
            }),
            image: item?.content?.properties?.cardImage
              ? retrunAssets(item?.content?.properties?.cardImage[0]?.url)
              : returnNotImage(),
            path: item?.content?.properties?.pagePath
              ? item?.content?.properties?.pagePath[0]?.url
              : null
          }}
          itemVariants={itemVariants}
        />
      ))}
    </motion.div>
  )
}

export default ResearchSection
